import * as React from "react";
import FacetToggle from "@warda/library-ui/core/Filter/FilterSelectChips/FacetToggle";
import { Condition } from "@warda/library-ui/interfaces";
const BTN_WIDTH = 30;
const SelectCond = ({ className, style, value, onChange }) => {
    const actionsConditions = React.useMemo(() => [
        {
            id: Condition.AND,
            label: "AND",
            selected: Condition.AND === value,
            width: BTN_WIDTH,
        },
        {
            id: Condition.OR,
            label: "OR",
            selected: Condition.OR === value,
            width: BTN_WIDTH,
        },
    ], [value]);
    return (React.createElement(FacetToggle, { className: className, style: style, actions: actionsConditions, onChange: onChange, help: "How filters works among them" }));
};
export default SelectCond;
